import Vue from 'vue'
/* import/no-named-as-default */
/* code */
import Vtooltip from 'v-tooltip'

Vue.use(Vtooltip)
